import type { Market } from '@/types/api';
import { fixtureIdOf } from './fixtures';

/* Non-component helpers shared by the board, the event page and the slip.
   Kept out of MarketCard.tsx because react-refresh/only-export-components
   fails lint on a file that exports both components and plain values. */

export const IconCalendar = (<><rect x="3" y="4.5" width="18" height="16" rx="2.5" /><path d="M3 9h18M8 3v3M16 3v3" /></>);
export const IconAlert = (<><path d="M12 3l9 16H3L12 3z" /><path d="M12 10v4M12 17h.01" /></>);
export const IconBack = (<><path d="M15 5l-7 7 7 7" /></>);

/* Kickoff formatter matching the prototype: "TONIGHT 7:50 PM", "SAT 1:45 PM". */
export function formatKickoff(iso: string): string {
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '';
  const time = d.toLocaleTimeString('en-AU', { hour: 'numeric', minute: '2-digit', hour12: true }).toUpperCase();
  const now = new Date();
  const sameDay = d.toDateString() === now.toDateString();
  const tomorrow = new Date(now); tomorrow.setDate(now.getDate() + 1);
  const isTomorrow = d.toDateString() === tomorrow.toDateString();
  if (sameDay) return `${d.getHours() >= 17 ? 'TONIGHT' : 'TODAY'} ${time}`;
  if (isTomorrow) return `TMRW ${time}`;
  return `${d.toLocaleDateString('en-AU', { weekday: 'short' }).toUpperCase()} ${time}`;
}

export function eventPath(market: Pick<Market, 'id'>): string {
  return `/bets/event/${encodeURIComponent(fixtureIdOf(market))}`;
}

